/*
 * Logout / session-expiry / failed-login all wipe localStorage so no auth
 * state survives. A blanket `localStorage.clear()` also wiped the user's list
 * preferences, so saved column presets, filter presets and starred quick
 * filters on the B2B/B2C booking and order lists vanished on every logout.
 *
 * `clearLocalStorage()` is a drop-in replacement for `localStorage.clear()`
 * that keeps those preference keys (and anything in `extraKeys`).
 */

/** Key prefixes owned by list UI preferences — never auth/session data. */
export const PRESERVED_KEY_PREFIXES = [
  "tms:list-presets:", // common/presets/presetService — column + filter presets
  "dv:", // common/DataView/adapters/localPersistence — grid state
  "booking-list-filters", // bookshipment Filter storageKey — starred / presets
  "tms-order-filter:", // ordershipment Filter storageKey — starred / presets
];

const isPreserved = (key) =>
  PRESERVED_KEY_PREFIXES.some((prefix) => key.startsWith(prefix));

/**
 * Clears localStorage except list-preference keys.
 * @param {string[]} [extraKeys] exact keys to keep as well (e.g. "userid2")
 */
export function clearLocalStorage(extraKeys) {
  const keep = {};
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && (isPreserved(key) || (extraKeys && extraKeys.includes(key)))) {
        keep[key] = localStorage.getItem(key);
      }
    }
    localStorage.clear();
    Object.keys(keep).forEach((key) => {
      if (keep[key] !== null) localStorage.setItem(key, keep[key]);
    });
  } catch (error) {
    // Storage disabled / private mode — nothing to clear or keep.
  }
}

export default clearLocalStorage;
